import { NgModule } from '@angular/core';
import { SomeLibComponent } from './some-lib.component';



@NgModule({
  declarations: [SomeLibComponent],
  imports: [
  ],
  exports: [SomeLibComponent]
})
export class SomeLibModule { }
